import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_SESSIONS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_SESSIONS_MANAGEMENT.STATE.SESSIONS]: null,
  [LOT_SESSIONS_MANAGEMENT.STATE.CURRENT_SESSION]: null,
  [LOT_SESSIONS_MANAGEMENT.STATE.TEMPLATE_SESSION]: null
}

const actions = {
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.GET_SESSIONS_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_SESSIONS_MANAGEMENT.MUTATIONS.GET_SESSIONS_LIST, resp.data)
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.GET_SESSION_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionType}/${model.sessionId}?${Vue.helpers.getQueryParamsString()}`
    }

    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_SESSIONS_MANAGEMENT.MUTATIONS.GET_SESSION_INFO, resp.data)
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.GET_TEMPLATE_SESSION_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionType}/template?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_SESSIONS_MANAGEMENT.MUTATIONS.GET_TEMPLATE_SESSION_INFO, resp.data)
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.CREATE_SESSION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionType}`,
      model: model.session
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.UPDATE_SESSION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionType}/${model.sessionId}`,
      model: model.session
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.DELETE_SESSION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.CLEAR_SESSION_INFO] ({ commit }) {
    commit(LOT_SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_SESSION_INFO)
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.CLEAR_SESSIONS_LIST] ({ commit }) {
    commit(LOT_SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_SESSIONS_LIST)
  },
  async [LOT_SESSIONS_MANAGEMENT.ACTIONS.CLEAR_TEMPLATE_SESSION_INFO] ({ commit }) {
    commit(LOT_SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_TEMPLATE_SESSION_INFO)
  }
}

const mutations = {
  [LOT_SESSIONS_MANAGEMENT.MUTATIONS.GET_SESSION_INFO] (state, session) {
    state[LOT_SESSIONS_MANAGEMENT.STATE.CURRENT_SESSION] = session
  },
  [LOT_SESSIONS_MANAGEMENT.MUTATIONS.GET_TEMPLATE_SESSION_INFO] (state, session) {
    state[LOT_SESSIONS_MANAGEMENT.STATE.TEMPLATE_SESSION] = session
  },
  [LOT_SESSIONS_MANAGEMENT.MUTATIONS.GET_SESSIONS_LIST] (state, sessions = []) {
    sessions.sort((s1, s2) => {
      return s1.sessionNumber - s2.sessionNumber
    })
    state[LOT_SESSIONS_MANAGEMENT.STATE.SESSIONS] = sessions
  },
  [LOT_SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_SESSION_INFO] (state) {
    state[LOT_SESSIONS_MANAGEMENT.STATE.CURRENT_SESSION] = null
  },
  [LOT_SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_TEMPLATE_SESSION_INFO] (state) {
    state[LOT_SESSIONS_MANAGEMENT.STATE.TEMPLATE_SESSION] = null
  },
  [LOT_SESSIONS_MANAGEMENT.MUTATIONS.CLEAR_SESSIONS_LIST] (state) {
    state[LOT_SESSIONS_MANAGEMENT.STATE.SESSIONS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
